export default __webpack_public_path__ + "static/media/screen4.cdb4c639.png";